<template>
  <table class="table">
    <thead>
      <tr>
        <!-- Emit the "columns" slot -->
        <slot name="columns">
          <th v-for="column in columns" :key="column">{{ column }}</th>
        </slot>
        <!-- Add a header for the "Actions" column -->
        <th>أزرار التحكم</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <td v-for="column in columns" :key="column" v-if="hasValue(item, column)">
          {{ itemValue(item, column) }}
        </td>
        <!-- Emit the "actions" slot for each row -->
        <td>
          <slot name="actions" :row="item"></slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'l-table',
  props: {
    columns: Array,
    data: Array,
  },
  methods: {
    hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    },
  },
};
</script>

<style>
/* Add any necessary table styles here */
</style>
